import createRequest from '../core/request'

/**
 * 获取同事列表
 */
export function get_all_colleagues(params) {
  return createRequest('SyncAPI').get('/get_all_colleagues_v2', {
    params
  })
}

/**
 * 获取同事基本信息
 */
export function get_colleague_info(params) {
  return createRequest('SyncAPI').get('/get_colleague_info_v2', {
    params
  })
}

/**
 * 获取同事详细信息
 */
export function get_colleague_detail(params) {
  return createRequest('SyncAPI').get('/get_colleague_detail', {
    params
  })
}

/**
 * 获取部门树
 */
export function get_relationship(params, data) {
  if (data && Object.keys(data).length > 0) {
    return createRequest('CORPAPI').post('/get_relationship_v2', data, {
      params
    })
  } else {
    return createRequest('CORPAPI').get('/get_relationship_v2', {
      params
    })
  }
}

/**
 * 根据部门获取同事列表
 */
export function get_department_colleague(params) {
  return createRequest('SyncAPI').get('/get_department_colleague_v2', {
    params
  })
}

/**
 * 获取上司列表
 */
export function get_colleague_superior(params) {
  return createRequest('SyncAPI').get('/get_superior_v2', {
    params
  })
}

/**
 * 获取下属列表
 */
export function get_colleague_subordinate(params) {
  return createRequest('SyncAPI').get('/get_colleague_subordinate_v2', {
    params
  })
}

/**
 * 邀请同事
 */
export function invite_member(params, data) {
  return createRequest('CORPAPI').post('/invite_member', data, {
    params
  })
}

/**
 * 获取组织架构
 */
export function get_member_relationship(params) {
  return createRequest('CORPAPI').get('/get_relationship_v2', {
    params
  })
}
/**
 * 获取企业头像
 */
export function get_corp_icon(params) {
  return createRequest('SyncAPI').get('/get_corp_icon', {
    params
  })
}

/**
 * 根据关键题搜索同事（最多50）
 */
export function search_colleagues(params) {
  return createRequest('SyncAPI').get('/search_colleagues_v2', {
    params
  })
}

/**
 * TODO:获取下属列表（含离职的）
 */
export function get_all_colleague_subordinate(params) {
  return createRequest('SyncAPI').get('/get_all_colleague_subordinate', {
    params
  })
}
